import { render } from "./WarmTipDialog.vue?vue&type=template&id=ec81a134&scoped=true"
import script from "./WarmTipDialog.vue?vue&type=script&lang=js"
export * from "./WarmTipDialog.vue?vue&type=script&lang=js"

import "./WarmTipDialog.vue?vue&type=style&index=0&id=ec81a134&scoped=true&lang=css"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec81a134"]])

export default __exports__